import { QueryKey, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
  getListingViews,
  ListingViewsResponse,
} from 'api/admin/listing/getListingViews'

export const listingViewsKey = (
  listingId: number,
  timeRange: { startDate: string; endDate: string }
) => ['listing-views', listingId, timeRange] as const

export const useListingViewsQuery = (
  listingId: number | undefined,
  timeRange: { startDate: string; endDate: string }
) => {
  return useQuery<
    ListingViewsResponse,
    AxiosError,
    ListingViewsResponse,
    QueryKey
  >({
    queryKey: listingViewsKey(listingId ?? 0, timeRange),
    queryFn: () => getListingViews(listingId!, timeRange),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: Boolean(listingId && timeRange.startDate && timeRange.endDate),
  })
}
